import * as calendar from '../calendar'
import { evnMap } from '../evn'
import { serviceOptionsMap } from '../options'

const moment = require('moment')
const validatePassword = (password) => {
  // Mindestens 8, höchstens 32 Zeichen. Muss einen Buchstaben, sowie eine Ziffer oder eines der folgenden Sonderzeichen enthalten: # ( ) [ ] { } ? ! $ % & / = * + ~ , . : < > @ € - _
  /* eslint-disable-next-line no-useless-escape */
  const validChars = /^[A-Za-z\d#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_\§\^]{8,32}$/g.test(password)
  const hasNumbers = /[0-9]/.test(password)
  const hasAlpha = /[A-Za-z]/.test(password)
  /* eslint-disable-next-line no-useless-escape */
  const hasSpecial = /[#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_]/.test(password)
  return validChars && (hasNumbers || hasSpecial) && hasAlpha
}

const validateYoungTariffBirthdate = (vm) => {
  return (birthdate) => {
    if (vm.savedTariff?.tariffExtra?.type === 'young') {
      const today = moment(new Date(), 'DD.MM.YYYY')
      const birthday = moment(birthdate, 'DD.MM.YYYY')
      today.subtract(28, 'years')
      return (today.diff(birthday) <= 0)
    }
    return true
  }
}

const validateVoucher = (voucher) => {
  return /^[0-9]{14,16}$/.test(voucher)
}

const validateIban = (iban) => {
  iban = iban.replace(/\s+/g, '')

  const ibanPattern = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/

  if (!ibanPattern.test(iban)) {
    return false
  }

  const rearranged = iban.slice(4) + iban.slice(0, 4)
  const converted = rearranged.split('').map(char => {
    if (char >= 'A' && char <= 'Z') {
      return (char.charCodeAt(0) - 55).toString()
    }
    return char
  }).join('')

  let remainder = 0
  for (let i = 0; i < converted.length; i++) {
    remainder = (remainder * 10 + parseInt(converted[i], 10)) % 97
  }

  return remainder === 1
}

const install = function (Vue, options = {}) {
  const $config = {
    brand: 'lidl',
    calendar,
    evnMap,
    serviceOptionsMap,
    validation: {
      validatePassword,
      validateVoucher,
      validateYoungTariffBirthdate,
      validateIban
    },
    ...options
  }

  Vue.mixin({
    computed: {
      $config () {
        return $config
      }
    }
  })
}

export default {
  install
}
